// These hard-coded group configs are temporary. They will be replaced by a
// DB-backed source served from the API (Ticket 8: configs -> table). Access
// codes in particular must move server-side and be validated via a public
// procedure (Ticket 10) — they are the real enrollment gate and cannot ship in
// the client bundle. Keep `getGroupConfig` as the single interface the UI reads
// from so swapping the data source behind it stays a no-op for components.
import type {GroupConfig} from '@client/pages/public/enroll/types';
import {cornerstoneConfig} from '@client/pages/public/enroll/groups/cornerstone';
import {hardhatConfig} from '@client/pages/public/enroll/groups/hardhat';

const GROUP_CONFIGS: GroupConfig[] = [cornerstoneConfig, hardhatConfig];

const GROUPS_BY_SLUG: Record<string, GroupConfig> = Object.fromEntries(
  GROUP_CONFIGS.map((group) => [group.slug.toLowerCase(), group]),
);

export function getGroupConfig(slug: string | undefined): GroupConfig | undefined {
  if (!slug) return undefined;
  return GROUPS_BY_SLUG[slug.toLowerCase()];
}

export function listGroupConfigs(): GroupConfig[] {
  return GROUP_CONFIGS;
}
